import React from "react";

const Copyright = () => {
  return (
    <div className="copyright">
      <p>
        2011 - 2024 © Copyright Ili Express. All Rights Reserved By{" "}
        <a href="https://www.adveits.com">QUCODES</a>
      </p>
    </div>
  );
};

export default Copyright;
